import { getOwnerName, text } from "@quickpoint.me/shared";
import { getAuth, GithubAuthProvider, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { cloneDeep } from "lodash-es";
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from "recoil";
import GithubIcon from "../../icons/github-mark-white.svg?react";
import GoogleIcon from "../../icons/web_dark_sq_na.svg?react";
import { setOwnerNameToSessionStorage } from "../../lib/ownerNameSessionStorage";
import { AuthScreenAtom, FirebaseUser } from "../../state/authAtoms";
import { LoginSuccessfulResetState } from "../../state/authSelectors";
import { IsInPortrait } from "../../state/selectors";
import { TermsOfService } from "./register/SignUp";
import { AuthPillButton, Banner } from "./styled/Components";
import { StyledInput } from "./styled/StyledInput";
import { track } from "../../lib/metrics";

export function LoginChoices() {
  const setFireBaseUser = useSetRecoilState(FirebaseUser);
  const setLoginSuccessfulResetState = useSetRecoilState(LoginSuccessfulResetState);
  const isInPortrait = useRecoilValue(IsInPortrait);
  const loginWithEmail = useRecoilCallback(({ set }) => () => {
    set(AuthScreenAtom, "loginEmail");
  });

  const loginWithPopUp = useRecoilCallback(() => async (provider: GoogleAuthProvider) => {
    const auth = getAuth();
    const result = await signInWithPopup(auth, provider);
    // The signed-in user info.
    const user = result.user;
    const jwt = await user.getIdToken();
    const getOwner = await getOwnerName(jwt);

    if (getOwner.success && getOwner.owners) {
      // recoil mungs the user and breaks firebase, so just copy it.
      const recoilUser = cloneDeep(user);
      setOwnerNameToSessionStorage(getOwner.owners[0]);
      setFireBaseUser(recoilUser);
      setLoginSuccessfulResetState(true);
      // Track login event
      track(user.uid, 'login', { provider: provider.providerId });
    }
  });

  const chooseGoogle = () => {
    const provider = new GoogleAuthProvider();
    provider.addScope("profile");
    provider.addScope("email");
    loginWithPopUp(provider);
  };

  const chooseGithub = () => {
    const provider = new GithubAuthProvider();
    loginWithPopUp(provider);
  };

  const goBack = useRecoilCallback(({ set }) => () => {
    set(AuthScreenAtom, "landing");
  });

  return (
    <StyledInput $isInPortrait={isInPortrait} data-testid="login-choices">
      <Banner />
      <div className="buttons">
        <AuthPillButton $variant="dark" onClick={() => chooseGoogle()}>
          <GoogleIcon aria-hidden="true" focusable="false" />
          {text.auth.continueGoogle}
        </AuthPillButton>
        <AuthPillButton $variant="dark" onClick={() => chooseGithub()}>
          <GithubIcon aria-hidden="true" focusable="false" />
          {text.auth.continueGithub}
        </AuthPillButton>
        <AuthPillButton onClick={() => loginWithEmail()}>
          {text.auth.continueEmail}
        </AuthPillButton>
        <AuthPillButton $variant="primaryOutline" onClick={() => goBack()}>
          {text.auth.back}
        </AuthPillButton>
        <TermsOfService />
      </div>
    </StyledInput>
  );
}
